import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  class: "badge text-bg-warning fs-13"
}
const _hoisted_5 = {
  key: 2,
  class: "badge text-bg-success fs-13"
}
const _hoisted_6 = {
  key: 0,
  class: "card mb-25 border-0 rounded-0 bg-white letter-spacing"
}
const _hoisted_7 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_8 = { class: "custom-search" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-md-8" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = {
  key: 1,
  class: "card mb-25 border-0 rounded-0 bg-white letter-spacing"
}
const _hoisted_13 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_14 = { class: "d-sm-flex align-items-center" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = {
  key: 0,
  class: "spinner-border text-white",
  role: "status"
}
const _hoisted_17 = { class: "d-flex align-items-center" }
const _hoisted_18 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_19 = { key: 2 }
const _hoisted_20 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_21 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_22 = {
  key: 0,
  class: "d-sm-flex align-items-center"
}
const _hoisted_23 = ["disabled"]
const _hoisted_24 = {
  key: 0,
  class: "spinner-border text-white",
  role: "status"
}
const _hoisted_25 = { class: "d-flex align-items-center" }
const _hoisted_26 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_27 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_center = _resolveComponent("center")!
  const _component_vue_good_table = _resolveComponent("vue-good-table")!
  const _component_PaginatorContent = _resolveComponent("PaginatorContent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h5", null, _toDisplayString(_ctx.note.note_ref), 1),
        _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1)),
        _createElementVNode("p", null, [
          _cache[8] || (_cache[8] = _createTextVNode(" Date de création : ", -1)),
          (_ctx.note.created_at)
            ? (_openBlock(), _createElementBlock("b", _hoisted_3, _toDisplayString(_ctx.getDate(_ctx.note.created_at)), 1))
            : _createCommentVNode("", true),
          _cache[9] || (_cache[9] = _createTextVNode(" | | ", -1)),
          _createElementVNode("b", null, _toDisplayString(_ctx.note.user_name), 1),
          _cache[10] || (_cache[10] = _createTextVNode(" | ", -1)),
          (_ctx.note.statut == 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, " Brouillon "))
            : (_openBlock(), _createElementBlock("span", _hoisted_5, " Enregistré "))
        ])
      ])
    ]),
    (_ctx.note.statut == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _cache[15] || (_cache[15] = _createElementVNode("div", { class: "card-header" }, [
            _createElementVNode("h5", null, "Scan référence bon")
          ], -1)),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("form", {
              onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.scanNote && _ctx.scanNote(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _cache[12] || (_cache[12] = _createElementVNode("label", null, "Référence bon :", -1)),
                      _withDirectives(_createElementVNode("input", {
                        placeholder: "Référence",
                        type: "text",
                        id: "scanFocus",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.scanRef) = $event)),
                        class: "form-control"
                      }, null, 512), [
                        [_vModelText, _ctx.scanRef]
                      ])
                    ])
                  ]),
                  _cache[13] || (_cache[13] = _createElementVNode("div", { class: "col-md-4" }, [
                    _createElementVNode("button", {
                      class: "btn btn-success me-3 mb-3 mt-3",
                      type: "submit"
                    }, [
                      _createElementVNode("i", { class: "ph ph-scan" })
                    ])
                  ], -1)),
                  _cache[14] || (_cache[14] = _createElementVNode("div", { class: "col-12" }, [
                    _createElementVNode("hr")
                  ], -1))
                ])
              ])
            ], 32)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.note.statut == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _cache[20] || (_cache[20] = _createElementVNode("div", { class: "card-header" }, [
            _createElementVNode("h5", null, "Bons disponibles")
          ], -1)),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("button", {
                class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0",
                type: "button",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addSelectedNotes && _ctx.addSelectedNotes(...args))),
                disabled: _ctx.loadAdd
              }, [
                (_ctx.loadAdd)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, _cache[16] || (_cache[16] = [
                      _createElementVNode("span", { class: "visually-hidden" }, "Loading...", -1)
                    ])))
                  : _createCommentVNode("", true),
                _cache[17] || (_cache[17] = _createTextVNode(" Ajouter ", -1)),
                _cache[18] || (_cache[18] = _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1))
              ], 8, _hoisted_15)
            ]),
            _createElementVNode("div", _hoisted_17, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getAvailable())),
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.available.searchTerm) = $event)),
                class: "form-control shadow-none text-black rounded-0",
                placeholder: "Chercher"
              }, null, 544), [
                [_vModelText, _ctx.available.searchTerm]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_vue_good_table, {
              columns: _ctx.columns,
              rows: _ctx.rowsAvailable,
              "select-options": {
          enabled: true,
          clearSelectionText: 'Annuler',
          selectionText: 'bons sélectionnés',
        },
              onSelectAll: _ctx.onSelectAllAvailable,
              onSelectedRowsChange: _ctx.onSelectionAvailable
            }, {
              emptystate: _withCtx(() => [
                _createVNode(_component_center, null, {
                  default: _withCtx(() => _cache[19] || (_cache[19] = [
                    _createTextVNode("Aucune entrées correspondantes trouvées", -1)
                  ])),
                  _: 1,
                  __: [19]
                })
              ]),
              "table-row": _withCtx((props) => [
                (props.column.field === 'type')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(_ctx.typeLabel(props.row.type)), 1)
                    ], 64))
                  : (props.column.field === 'created_at')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(_ctx.getDate(props.row.created_at)), 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(props.formattedRow[props.column.field]), 1))
              ]),
              _: 1
            }, 8, ["columns", "rows", "onSelectAll", "onSelectedRowsChange"]),
            _createVNode(_component_PaginatorContent, {
              pagination: _ctx.available,
              offset: 9,
              onPaginate: _ctx.getAvailable
            }, null, 8, ["pagination", "onPaginate"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_20, [
      _cache[25] || (_cache[25] = _createElementVNode("div", { class: "card-header" }, [
        _createElementVNode("h5", null, "Bons ajoutés")
      ], -1)),
      _createElementVNode("div", _hoisted_21, [
        (_ctx.note.statut == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              _createElementVNode("button", {
                class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-danger fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0",
                type: "button",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.removeSelectedNotes && _ctx.removeSelectedNotes(...args))),
                disabled: _ctx.loadRemove
              }, [
                (_ctx.loadRemove)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, _cache[21] || (_cache[21] = [
                      _createElementVNode("span", { class: "visually-hidden" }, "Loading...", -1)
                    ])))
                  : _createCommentVNode("", true),
                _cache[22] || (_cache[22] = _createTextVNode(" Supprimer ", -1)),
                _cache[23] || (_cache[23] = _createElementVNode("i", { class: "flaticon-delete position-relative ms-5 fs-12" }, null, -1))
              ], 8, _hoisted_23)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_25, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.getAdded())),
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.added.searchTerm) = $event)),
            class: "form-control shadow-none text-black rounded-0",
            placeholder: "Chercher"
          }, null, 544), [
            [_vModelText, _ctx.added.searchTerm]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createVNode(_component_vue_good_table, {
          columns: _ctx.columns,
          rows: _ctx.rowsAdded,
          "select-options": {
          enabled: _ctx.note.statut == 0,
          selectOnCheckboxOnly: true,
          clearSelectionText: 'Annuler',
          selectionText: 'bons sélectionnés',
        },
          onSelectAll: _ctx.onSelectAllAdded,
          onSelectedRowsChange: _ctx.onSelectionAdded
        }, {
          emptystate: _withCtx(() => [
            _createVNode(_component_center, null, {
              default: _withCtx(() => _cache[24] || (_cache[24] = [
                _createTextVNode("Aucune entrées correspondantes trouvées", -1)
              ])),
              _: 1,
              __: [24]
            })
          ]),
          "table-row": _withCtx((props) => [
            (props.column.field === 'type')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.typeLabel(props.row.type)), 1)
                ], 64))
              : (props.column.field === 'created_at')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(_ctx.getDate(props.row.created_at)), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(props.formattedRow[props.column.field]), 1))
          ]),
          _: 1
        }, 8, ["columns", "rows", "select-options", "onSelectAll", "onSelectedRowsChange"]),
        _createVNode(_component_PaginatorContent, {
          pagination: _ctx.added,
          offset: 9,
          onPaginate: _ctx.getAdded
        }, null, 8, ["pagination", "onPaginate"])
      ])
    ])
  ], 64))
}